export * from './lib/bn-customer-info-v2';
// export * from '../../../../bn-entry-lib/libs/bn-entry/src/lib/bn-registration.interface';
